import { EmbeddedLegalConsentModal } from '@/shared/components/EmbeddedLegalConsentModal'
import { useLegalConsent } from '@/shared/hooks/useLegalConsent'

export function LegalConsentManager() {
  const {
    showModal,
    documents,
    isLoading,
    error,
    acceptConsent,
    closeModal
  } = useLegalConsent()

  // Don't render anything if loading or error
  if (isLoading || error || !documents.terms || !documents.privacy) {
    return null
  }

  // Only show modal if needed
  if (!showModal) {
    return null
  }

  return (
    <EmbeddedLegalConsentModal
      isOpen={showModal}
      onAccept={acceptConsent}
      onClose={closeModal}
      termsDocument={documents.terms}
      privacyDocument={documents.privacy}
    />
  )
}